import { STORAGE_KEYS } from '~constants'

const getRootPath = () => {
  const rootPath = localStorage.getItem(STORAGE_KEYS.ROOT_PATH) || ''
  return rootPath
}

export default getRootPath
